export const INITIAL_FILTER_PRODUCTION_CYCLE = {
  detergentProducer: '',
  progress: ''
};

export const INITIAL_SORT_PRODUCTION_CYCLE = {
  detergentName: '',
  id: 'DESC'
};
